import React from 'react';
import DatePicker from '../shared/DatePicker';
import { getDateLimits } from '../onboardingQuestions';

interface StepProps {
  answer: any;
  onAnswer: (value: any) => void;
  answers: Record<string, any>;
}

const RaceDateStep: React.FC<StepProps> = ({ answer, onAnswer }) => {
  const limits = getDateLimits('race_date');

  return (
    <DatePicker
      value={answer || null}
      onChange={onAnswer}
      min={limits.min}
      max={limits.max}
    />
  );
};

export default RaceDateStep;
